import decoder from '../../../lib/decoder';

function ModelCartGroup() {
	this.type = '';
	this.name = '';
	this.canDelete = false;
	this.isHidden = false;
	this.items = [];
}

ModelCartGroup.create = function (json) {
	if (!json) json = {};
	
	let model = new ModelCartGroup();
	
	model.name = decoder.stringValue(json['NAME'], '');
	model.canDelete = decoder.boolValue(json['CAN_DELETE'], false);
	model.isHidden = decoder.boolValue(json['HIDE'], false);
	
	return model;
};

export default ModelCartGroup;